import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${props => props.theme.spacing.sp16};

  label {
    margin-right: 0;
  }
`

export const ExpandButton = styled.button`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: space-between;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  color: ${props => props.theme.colors.text.default};
`

export const RefundMethodLabel = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
  color: ${props => (props.isEnabled ? props.theme.colors.text.default : props.theme.colors.text.subtle)};
`

export const ErrorDot = styled.span`
  width: ${props => props.theme.spacing.sp8};
  height: ${props => props.theme.spacing.sp8};
  border-radius: 50%;
  background-color: ${props => props.theme.colors.danger.default};
`
